import { Component,OnInit, ContentChildren, QueryList, ElementRef, ViewChildren } from '@angular/core';
import { AuthenticationResult } from '../models/authentication.model';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { HsgFieldInput } from '../../../../node_modules/hsg';


@Component({
  selector: 'auth-user-details',
  templateUrl: './auth-user-details.component.html',
  styleUrls: ['./auth-user-details.component.css'],
})

export class AuthUserDetailsComponent extends AuthBaseComponent implements OnInit {

  @ViewChildren(HsgFieldInput) inputs : QueryList<HsgFieldInput>;

  public loginOriginAction:string = "";
  ngOnInit(): void {
    sessionStorage.removeItem("checkOpenCalls");
    sessionStorage.setItem("currentWindow", "כניסה למידע אישי")
    this.loginOriginAction = sessionStorage.getItem("loginOriginAction");
  }

  submit(form): void {
    const element =  this.inputsQuery.map(elm => elm.elementRef.nativeElement).find(elm => elm.classList.contains('ng-invalid'));
    if(element){
      element.setAttribute('aria-invalid', true);
      setTimeout(() => element.focus(), 0);
    }
    if (form.valid) {
      this.pending = true;
      this.serverError = null;
      //console.log("sent parametes", { UserId: form.value.uid, FullPhone: form.value.phone });
      this.authUserService.sendAuthData("ValidateUser", { UserId: form.value.uid, FullPhone: form.value.phone })
        .subscribe((res: AuthenticationResult) => {
          if(res.Details.hasOpenContactCalls){
              sessionStorage.setItem("checkOpenCalls","hasOpenCalls");
          }
            this.modalService.close(res.Details); 
        },() => this.pending = false,
          () => this.pending = false
        )
    }
    this.buildFormAccessibility();
  }
}
